var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "huggies-register"
  }, [_c('div', {
    staticClass: "wrap-content"
  }, [_c('h6', [_vm._v(" 寶寶生日/預產期* "), _vm.v$.form.year.$error || _vm.v$.form.month.$error || _vm.v$.form.day.$error ? _c('span', {
    staticClass: "error"
  }, [_vm._v("請輸入寶寶生日/預產期")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.year,
      expression: "form.year"
    }],
    staticClass: "form-control custom-select",
    class: {
      invalid: _vm.v$.form.year.$error
    },
    staticStyle: {
      "width": "31%",
      "margin-right": "3%"
    },
    attrs: {
      "id": "year",
      "name": "year",
      "disabled": _vm.formLoading
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v("出生年")]), _c('option', {
    attrs: {
      "value": "2024"
    }
  }, [_vm._v("2024")]), _c('option', {
    attrs: {
      "value": "2023"
    }
  }, [_vm._v("2023")]), _c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022")]), _c('option', {
    attrs: {
      "value": "2021"
    }
  }, [_vm._v("2021")]), _c('option', {
    attrs: {
      "value": "2020"
    }
  }, [_vm._v("2020")]), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019")]), _c('option', {
    attrs: {
      "value": "2018"
    }
  }, [_vm._v("2018")])]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.month,
      expression: "form.month"
    }],
    staticClass: "form-control custom-select",
    class: {
      invalid: _vm.v$.form.month.$error
    },
    staticStyle: {
      "width": "31%",
      "margin-right": "3%"
    },
    attrs: {
      "id": "month",
      "name": "month",
      "disabled": _vm.formLoading
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v("出生月")]), _vm._l(12, function (i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))]);
  })], 2), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.day,
      expression: "form.day"
    }],
    staticClass: "form-control custom-select",
    class: {
      invalid: _vm.v$.form.day.$error
    },
    staticStyle: {
      "width": "31%"
    },
    attrs: {
      "id": "day",
      "name": "day",
      "disabled": _vm.formLoading
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "day", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v("出生日")]), _vm._l(_vm.dayOptions, function (i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))]);
  })], 2)]), _c('h6', [_vm._v(" 爸爸媽媽姓名*"), _vm.v$.form.parent_name.$error ? _c('span', {
    staticClass: "error"
  }, [_vm._v("請輸入姓名")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.parent_name,
      expression: "form.parent_name"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.v$.form.parent_name.$error
    },
    attrs: {
      "id": "parent_name",
      "name": "parent_name",
      "placeholder": "請輸入姓名",
      "required": "",
      "disabled": _vm.formLoading
    },
    domProps: {
      "value": _vm.form.parent_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "parent_name", $event.target.value);
      }
    }
  })]), _c('h6', [_vm._v(" 手機號碼*"), _vm.v$.form.mobile.$error ? _c('span', {
    staticClass: "error"
  }, [_vm._v("請輸入正確的手機號碼")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.mobile,
      expression: "form.mobile"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.v$.form.mobile.$error
    },
    attrs: {
      "type": "tel",
      "id": "mobile",
      "name": "mobile",
      "placeholder": "請輸入手機號碼",
      "pattern": "09[0-9]{8}",
      "required": "",
      "disabled": _vm.formLoading
    },
    domProps: {
      "value": _vm.form.mobile
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value);
      }
    }
  })]), _c('h6', [_vm._v(" EMAIL*"), _vm.v$.form.email.$error ? _c('span', {
    staticClass: "error"
  }, [_vm._v("請輸入電子信箱")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.email,
      expression: "form.email"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.v$.form.email.$error
    },
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "請輸入電子信箱",
      "required": "",
      "disabled": _vm.formLoading
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "btnwrap fixedbottom",
    attrs: {
      "id": "nextbtn"
    },
    on: {
      "click": _vm.handleNext
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/btn_next.png"),
      "alt": "下一步"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }